import 'bootstrap/dist/css/bootstrap.min.css';
import { createContext, useState } from "react";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import '../App.scss';
import Configs from '../configs.json';
import Campaign from './pages/campaign/Campaign';
import NotFound from './pages/NotFound';
import TabHome from './pages/TabHome';
import Template from './pages/template/Template';
import ScrollToTop from './ScrollToTop';

import {
   Link,
   Route,
   Routes
} from "react-router-dom";

export const ApplicationContext = createContext(null);

export default function App() {

   const g_sessionTokenKey = 'sessionToken';

   const [searchResults, setSearchResults] = useState(null);
   const [searchText, setSearchText] = useState('');
   const [bulkText, setBulkText] = useState('');

   const [userIdentity, setUserIdentity] = useState();
   const [hasUserIdentityResponse, setHasUserIdentityResponse] = useState(false);

   useState(() => {
      // check for new sessions in the url
      let sessionToken = null;
      try {
         sessionToken = new URLSearchParams(window.location.search).get('sessionToken').trim();
         if (sessionToken.length === 0) {
            throw new Error();
         }
      } catch (ex) {
         sessionToken = null;
      }
      if (sessionToken != null) {
         window.localStorage.setItem(g_sessionTokenKey, sessionToken);
         window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
      }
   });

   const [sessionToken] = useState(() => {
      try {
         return window.localStorage.getItem(g_sessionTokenKey);
      } catch (ex) {
      }
      return null;
   });

   useState(() => {

      if (sessionToken == null) {
         setHasUserIdentityResponse(true);
      } else {

         fetch(
            `${Configs.api.endpoint}/misc/identity`, {
            method: 'GET',
            cache: 'no-cache',
            headers: {
               "Content-Type": "application/json",
               "x-session-token": sessionToken
            }
         })
            .then((response) => {
               if (response.status === 200) {
                  return response.json();
               }
               setHasUserIdentityResponse(true);
               return null;
            })
            .then((content) => {
               setHasUserIdentityResponse(true);
               if (content != null) {
                  setUserIdentity(content.callerIdentity);
               }
            });
      }
   });


   if (hasUserIdentityResponse === false) {
      return null;
   }

   if (userIdentity == null || userIdentity.length === 0) {
      window.location.href =
         `https://docs.pubsub.tpxapps.com/ssorelay?redirect=${window.location.href}`;
      return null;
   }

   return (

      <ApplicationContext.Provider value={{
         getSessionToken: () => {
            return sessionToken;
         },
         isLocalhost: window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1' ||
            window.location.hostname === '::1'
      }}>
         <Container
            key={'theContainer'}
            fluid
         >
            <Row className={'header'}>
               <Col>
                  <Link
                     to="/"
                     onClick={() => {
                        setSearchResults(null);
                        setSearchText('');
                     }}
                     className={'unselectable'}
                     style={{ textDecoration: 'none' }}>
                     <h1
                        style={{ margin: '.6rem 0 .4rem .2rem', fontSize: '1.25rem', fontWeight: 'bold' }}
                     >
                        <img
                           alt=""
                           src="/bee.png"
                           style={{ height: '2rem', marginRight: '.4rem', marginBottom: '.2rem' }} />
                        TPx Bees</h1>
                  </Link>
               </Col>
               <Col
                  style={{ display: 'flex', flexDirection: 'row-reverse' }}
               >
                  <span
                     className={'unselectable'}
                     style={{ margin: '.9rem .8rem 0rem 0rem', fontSize: '1rem', fontWeight: 'bold' }}
                  >{userIdentity}
                  </span>
               </Col>
            </Row>

            <Row style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
               <Col
                  xs={12}
                  md={9}
                  xxl={7}
                  style={{
                     boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.2), inset 0 -1px 0 rgba(0, 0, 0, 0.2), inset 1px 0 0 rgba(0, 0, 0, 0.2), inset -1px 0 0 rgba(0, 0, 0, 0.2)',
                     backgroundColor: '#fafafa',
                     minHeight: '50rem',
                     padding: '2rem',
                  }}
               >
                  <ScrollToTop />
                  <Routes>
                     <Route path="/"
                        element={
                           <TabHome
                              searchText={searchText}
                              setSearchText={setSearchText}
                              searchResults={searchResults}
                              setSearchResults={setSearchResults}
                              bulkText={bulkText}
                              setBulkText={setBulkText}
                           />
                        }
                     />
                     <Route path="/templates"
                        element={
                           <TabHome
                              searchText={searchText}
                              setSearchText={setSearchText}
                              searchResults={searchResults}
                              setSearchResults={setSearchResults}
                              bulkText={bulkText}
                              setBulkText={setBulkText}
                           />
                        }
                     />
                     <Route path="/dashboard"
                        element={
                           <TabHome
                              searchText={searchText}
                              setSearchText={setSearchText}
                              searchResults={searchResults}
                              setSearchResults={setSearchResults}
                              bulkText={bulkText}
                              setBulkText={setBulkText}
                           />
                        }
                     />
                     <Route path="/campaign/:campaignID" element={<Campaign />} />
                     <Route path="/template/:templatesID" element={<Template />} />
                     <Route path="*" element={<NotFound />} />
                  </Routes>
               </Col>
            </Row>

            <Row style={{
               display: 'flex',
               flexDirection: 'row',
               justifyContent: 'center',
               marginTop: '10rem',
               fontSize: '.8rem',
               color: '#888'
            }}>
               <Col>
                  <hr style={{ margin: '0' }} />
                  <div style={{ textAlign: 'center' }}>
                     <div
                        style={{ margin: '1rem 0 1rem 0' }}
                     >
                        <img
                           alt=""
                           src="/bee.png"
                           style={{ height: '4rem' }} />
                     </div>
                     TPx Bees<br />
                     &copy; 2021-{new Date().getFullYear()} TPx Communications<br />All rights reserved
                  </div>
               </Col>
            </Row>
         </Container>
      </ApplicationContext.Provider>
   );
};
